const classView = () => import('@/page/class')
const classList = () => import('@/page/class/class-list')
const classDetail = () => import('@/page/class/class-detail')
const classResourse = () => import('@/page/class/class-menu/resourse')
const classMaillist = () => import('@/page/class/class-menu/maillist')
const classAssessment = () => import('@/page/class/class-menu/assessment')
const classAlbum = () => import('@/page/class/class-menu/album')

export default [
  {
    path: '/class',
    name: 'class',
    component: classView,
    children: [
      {
        path: 'class-list',
        name: 'class-list',
        component: classList
      },
      {
        path: 'class-detail',
        name: 'class-detail',
        component: classDetail
      },
      {
        path: 'class-assessment',
        name: 'class-assessment',
        component: classAssessment
      },
      {
        path: 'class-resourse',
        name: 'class-resourse',
        component: classResourse
      },
      {
        path: 'class-album',
        name: 'class-album',
        component: classAlbum
      },
      {
        path: 'class-maillist',
        name: 'class-maillist',
        component: classMaillist
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/class/index.js